import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { FeaturedProducts } from '../components/sections/FeaturedProducts';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';

export const HomePage: React.FC = () => {
  return (
    <main className="min-h-screen flex flex-col" style={{ backgroundColor: '#E8F5E9' }}>
      <Header />
      <div className="flex-grow">
        <Hero />
        <FeaturedProducts />
        <WhyChooseUs />
      </div>
      <Footer />
    </main>
  );
};

